import { render, staticRenderFns } from "./matchConf.vue?vue&type=template&id=5dd9c931&scoped=true&"
import script from "./matchConf.vue?vue&type=script&lang=js&"
export * from "./matchConf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd9c931",
  null
  
)

export default component.exports